import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { clampedTransactionPercentage } from "./helper/clampedTransactionPercentage";

const useStyles = makeStyles(() => ({
  used: {
    backgroundColor: "#005F87",
    height: 6,
    borderRadius: "5px 0 0 5px",
    zIndex: 2
  },
  usedExceeded: {
    backgroundColor: "#DC6914"
  },
  usedAllUsed: {
    backgroundColor: "#DC0000"
  },
  expiredUsed: {
    backgroundColor: " #00000080",
    height: 6,
    borderRadius: 5
  },
  percentageText: {
    textAlign: "left",
    fontSize: 12,
    fontWeight: 400,
    marginLeft: 8,
    color: "#6E6E6E"
  },
  percentageTextExceeded: {
    color: "#DC6914"
  },
  percentageTextAllUsed: {
    color: "#DC0000"
  },
  barContainerActive: {
    background: "#ffffff !important"
  },
  barContainer: {
    flexGrow: 1,
    height: 6,
    borderRadius: 5,
    background: "#E3FAFF",
    overflow: "hidden",
    position: "relative",
    width: 104,
    maxWidth: 104,
    display: "flex",
    zIndex: 1
  },
  expiredBarContainer: {
    backgroundColor: "var(--Background-disabled-light, #00000026)"
  }
}));

interface MinifiedTransactionQuotaBarProps {
  usedTransactions: number;
  transactionLimit: number;
  barContainerClass?: string;
  status?: string;
}

const MinifiedTransactionQuotaBar: React.FC<
  MinifiedTransactionQuotaBarProps
> = ({ usedTransactions, transactionLimit, barContainerClass, status }) => {
  const classes = useStyles();

  const percentage = Math.round((usedTransactions / transactionLimit) * 100);
  const exceeded = usedTransactions > transactionLimit;
  const allUsed = usedTransactions === transactionLimit;
  const isExpired = status === "Expired" || status === "Deactivated";

  return (
    <Box display="flex" alignItems="center">
      <Box>
        <Box
          className={`${classes.barContainer}${
            isExpired ? " " + classes.expiredBarContainer : ""
          }${barContainerClass ? " " + barContainerClass : ""}`}
        >
          {isExpired ? (
            <Box
              className={classes.expiredUsed}
              sx={{
                width: `${clampedTransactionPercentage(
                  usedTransactions,
                  transactionLimit
                )}%`
              }}
            />
          ) : (
            <Box
              className={
                exceeded
                  ? `${classes.used} ${classes.usedExceeded}`
                  : allUsed
                  ? `${classes.used} ${classes.usedAllUsed}`
                  : classes.used
              }
              sx={{
                width: `${clampedTransactionPercentage(
                  usedTransactions,
                  transactionLimit
                )}%`
              }}
            />
          )}
        </Box>
      </Box>
      <Typography
        className={
          isExpired
            ? classes.percentageText
            : exceeded
            ? `${classes.percentageText} ${classes.percentageTextExceeded}`
            : allUsed
            ? `${classes.percentageText} ${classes.percentageTextAllUsed}`
            : classes.percentageText
        }
      >
        {percentage}%
      </Typography>
    </Box>
  );
};

export default MinifiedTransactionQuotaBar;
